import { createFileRoute } from "@tanstack/react-router";
import ServicesIndex from "@/pages/site/ServicesIndex";

export const Route = createFileRoute("/services/")({
  component: () => <ServicesIndex />,
});
